export const styles = {
  listItemButton: {
    px: 0,
    py: 0.75,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
};
